import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'

import FaClose from 'react-icons/fa/times-circle'
import FaCaretRight from 'react-icons/fa/caret-right'

@autobind
class WorkInfosEditionModal extends Component {
  constructor (props) {
    super(props)
    let tags = this.props.work && this.props.work.tags && this.props.work.tags.join(', ')
    this.state = {
      title: this.props.work.title,
      description: this.props.work.description,
      tags: tags,
      posting: false
    }
  }

  closeModal () {
    this.props.onCloseModal()
  }

  onEditWorkInfos (e) {
    e.preventDefault()
    this.setState({posting: true})
    this.props.type !== 'tags'
      ? this.editWorksTitleAndDesc()
      : this.editWorksTags()
  }

  editWorksTitleAndDesc () {
    API.put(`/v3/works/${this.props.work.id}?include=work.names`, {title: this.state.title, description: this.state.description })
    .then(response => {
      this.props.work.onEditWorkInfos(response.data.work)
      this.closeModal()
    })
  }

  editWorksTags () {
    let tags = this.state.tags.split(', ')
    API.put(`/v3/works/${this.props.work.id}?include=work.details`, { tags: tags })
    .then((response) => {
      this.props.work.onEditWorkInfosTags(response.data.work.tags)
      this.closeModal()
    })
  }

  handleTitleChange (event) {
    this.setState({title: event.target.value})
  }

  handleDescriptionChange (event) {
    this.setState({description: event.target.value})
  }

  handleTagsChange (event) {
    this.setState({tags: event.target.value})
  }

  render () {
    return (
      <div className='modal-content'>
        <div className='modal-header'>
          <h4 className='modal-title'>You are editing this work</h4>
          <span className='modal__close' onClick={this.closeModal}>
            <FaClose />
          </span>
        </div>
        <form name='editForm' onSubmit={this.onEditWorkInfos}>
          <div className='modal-body'>
            {this.props.type === 'title' && <div className='form-group required'>
              <label htmlFor='workTitle'>Title: </label>
              <input id='workTitle' value={this.state.title} onChange={this.handleTitleChange} className='form-control' required='required' />
            </div>}
            {this.props.type === 'desc' && <div className='form-group'>
              <label htmlFor='workDescription'>Description:</label>
              <textarea id='workDescription' value={this.state.description} onChange={this.handleDescriptionChange} className='form-control' rows='8' />
            </div>}
            {this.props.type === 'tags' && <div className='form-group'>
              <label htmlFor='workTags'>Tags <span className='text-muted'>(lemon, apple, strawberry)</span>: </label>
              <input id='workTags' value={this.state.tags} onChange={this.handleTagsChange} className='form-control' />
            </div>}
          </div>
          <div className='modal-footer'>
            <span className='btn btn-link' onClick={this.closeModal}>Cancel</span>
            <button className='btn btn-primary' type='submit' disabled={this.state.title === '' || this.state.description === '' || this.state.posting}>Save <FaCaretRight /></button>
          </div>
        </form>
      </div>
    )
  }
}

export default WorkInfosEditionModal

WorkInfosEditionModal.propTypes = {
  work: PropTypes.object,
  onCloseModal: PropTypes.func,
  type: PropTypes.string
}



// WEBPACK FOOTER //
// ./components/work/WorkInfosEditionModal.js